import { Node as ContentBlock } from "./Node"

export { default as Marks } from "./Marks"
export { default as Text } from "./Text"
export { default as Paragraph } from "./Paragraph"
export { default as List } from "./List"
export { default as Quote } from "./Quote"

export default ContentBlock
